import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function GovernanceFAQCallout({ heading, body }) {
  return (
    <div className="bg-brand-navy rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-start gap-5">
      <div className="w-11 h-11 rounded-[10px] bg-white/10 flex items-center justify-center shrink-0">
        <ShieldCheck className="w-5 h-5 text-brand-teallight" />
      </div>
      <div>
        <h3 className="text-lg font-bold text-white tracking-tight">{heading}</h3>
        <p className="mt-2 text-sm text-white/70 leading-relaxed">{body}</p>
        <Link
          to="/governance-faq"
          className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand-teallight hover:text-white transition-colors"
        >
          View the Governance &amp; Trust FAQ <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}